<template>
  <el-container class="ranking" >
    <el-header class="header-style">
    <el-divider content-position="left">排名</el-divider>
  </el-header>
  <el-main class="main-style">
    <div class="ranking_list public">
      <el-row style="width: 100%"  :gutter="30">
        <el-col :span="6" :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
          <div class="col_ranking">
            <div class="ranking_title" v-if="false"  style="margin-bottom: .4rem">IM业绩/销售业绩排名</div>
            <el-dropdown  @command="handleCommandCompanyAll" style="margin-bottom: .4rem">
              <span class="el-dropdown-link">
                {{changeValue}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">IM业绩排名</el-dropdown-item>
                <el-dropdown-item :command="2">销售业绩排名</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-tabs  v-model="activeName" @tab-click="handleClickIm">
              <el-tab-pane label="日" name="first">
              </el-tab-pane>
              <el-tab-pane label="周" name="second">
                <div class="blocka"></div>
              </el-tab-pane>
              <el-tab-pane label="月" name="third">
                <div class="blocka"></div>
              </el-tab-pane>
              <div class="tabs_top public">
                <span class="count" style="width: 10%">排名</span>
                <span class="count count_name" style="width: 20%">姓名</span>
                <span class="count count_name" style="width: 20%">云上</span>
                <span class="count count_name" style="width: 20%">套餐</span>
                <span class="count count_name" style="width: 20%">单品</span>
                <span class="count count_num" style="width: 20%">订单单量</span>
              </div>
              <div class="m-tabs-content" >
                <div
                  v-for="(item, index) in rankingBySuccessOrder"
                  :key="index"
                  class="tabs_top public"
                  style="border-bottom: 1px solid #eeeeee">
                  <span  class="count" style="width: 10%">{{index + 1}}</span>
                  <span  class="count count_name" style="width: 20%">{{item.username}}</span>
                  <span  class="count count_name" style="width: 20%">{{item.could_count}}</span>
                  <span  class="count count_name" style="width: 20%">{{item.meal_count}}</span>
                  <span  class="count count_name" style="width: 20%">{{item.item_count}}</span>
                  <span  class="count count_num" style="width: 20%">{{item.all_counts}}</span>
                </div>
              </div>
            </el-tabs>
            <div class="tabs_position">
              <span>云上：{{total_success_count.total_could_count}}</span>
              <span>套餐：{{total_success_count.total_meal_count}}</span>
              <span>单品：{{total_success_count.total_item_count}}</span>
              <span>订单单量：{{total_success_count.total_all_counts}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6" :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
          <div class="col_ranking">
            <div class="ranking_title"  style="margin-bottom: .4rem">销售通话排名</div>
            <el-tabs  v-model="activeName2" @tab-click="handleClickXS">
              <el-tab-pane label="日" name="first">
              </el-tab-pane>
              <el-tab-pane label="周" name="second">
                <div class="blocka">
                </div>
              </el-tab-pane>
              <el-tab-pane label="月" name="third">
                <div class="blocka">
                </div>
              </el-tab-pane>
              <div class="tabs_top public">
                <span class="count" style="width: 20%">排名</span>
                <span class="count count_name" style="width: 20%">姓名</span>
                <span class="count count_num" style="width: 30%">通话个数</span>
                <span class="count count_num" style="width: 30%">通话时长</span>
              </div>
              <div class="m-tabs-content" >
                <div
                  v-for="(item, index) in rankingByCallDuration"
                  :key="index"
                  class="tabs_top public"
                  style="border-bottom: 1px solid #eeeeee">
                  <span class="count" style="width: 20%">{{item.sortBy}}</span>
                  <span class="count count_name" style="width: 20%">{{item.username}}</span>
                  <span class="count count_num" style="width: 30%">{{item.duration_count}}</span>
                  <span class="count count_num" style="width: 30%">{{item.sum_duration}}</span>
                </div>
              </div>
            </el-tabs>
            <div class="tabs_position">
              <span>通话个数：{{total_duration_count.total_duration_numbers}}</span>
              <span>通话时长：{{total_duration_count.total_duration_times}}</span>
              <span>平均通话时长：{{total_duration_count.total_avg_times}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6" :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
          <div class="col_ranking">
            <div class="ranking_title"  style="margin-bottom: .4rem">IM套电排名</div>
            <el-tabs  v-model="activeName4" @tab-click="handleClickImRanking">
              <el-tab-pane label="日" name="first">
              </el-tab-pane>
              <el-tab-pane label="周" name="second">
                <div class="blocka"></div>
              </el-tab-pane>
              <el-tab-pane label="月" name="third">
                <div class="blocka"></div>
              </el-tab-pane>
              <div class="tabs_top public">
                <span class="count" style="width: 30%">排名</span>
                <span class="count count_name" style="width: 35%">姓名</span>
                <span class="count count_num" style="width: 35%">套电量</span>
              </div>
              <div class="m-tabs-content" >
                <div
                  v-for="(item, index) in rankingByImInputs"
                  :key="index"
                  class="tabs_top tabs_topBorder public">
                  <span class="count" style="width: 30%">{{item.sortBy}}</span>
                  <span class="count count_name" style="width: 35%">{{item.im_name}}</span>
                  <span class="count count_num" style="width: 35%">{{item.input_count}}</span>
                </div>
              </div>
            </el-tabs>
            <div class="tabs_position">
              <span>套电量：{{total_input_count.total_input_count}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6" :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
          <div class="col_ranking">
            <div class="ranking_title"  style="margin-bottom: .4rem">仓位等级排名</div>
            <el-tabs  v-model="activeName3" @tab-click="handleClick">
              <div class="tabs_top public">
                <span class="count" style="width: 30%">排名</span>
                <span class="count count_name" style="width: 35%">姓名</span>
                <span class="count count_num" style="width: 35%">仓位等级</span>
              </div>
              <div class="m-tabs-content" style="height: 7.5rem">
                <div
                  v-for="(item, index) in rankingByUserLevel"
                  :key="index"
                  class="tabs_top tabs_topBorder public">
                  <span class="count" style="width: 30%">{{item.sortBy}}</span>
                  <span class="count count_name" style="width: 35%">{{item.username}}</span>
                  <span class="count count_num" style="width: 35%">{{item.store_space}}/{{item.level}}</span>
                </div>
              </div>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'clues_manage',
  data () {
    return {

      changeValue: 'IM业绩排名',
      optionProps: {
        value: 'id',
        label: 'Provincial',
        children: 'son'
      },
      activeName: 'first',
      activeName2: 'first',
      activeName3: 'first',
      activeName4: 'first',
      ranking: {},
      rankingBySuccessOrder: [],
      rankingByCallDuration: [],
      rankingByImInputs: [],
      rankingByUserLevel: [],
      percentCompanyAll: ['', 'IM业绩排名', '销售业绩排名'],
      rankingByIMSellCommand: 1,
      rankingByIMSellIndex: 1,
      total_success_count: '',
      total_input_count: '',
      total_duration_count: ''
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {},
  methods: {
    tableColumn (prop) {
      let width = ''
      if (prop === 'page_title') {
        width = 140
      }
      return width
    },
    handleClickImRanking (tab, event) {
      this.handleGetIMRankingNum(tab.index)
    },
    handleGetIMRankingNum (index) {
      // IM套电
      this.$axios.get('/api/thread/im_input_sort', {
        params: {
          date_type: parseInt(index) + 1
        }
      })
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.ranking = data.data
            this.rankingByImInputs = data.data.rankingByImInputs
            this.total_input_count = data.data.total_input_count
          }
        })
    },
    handleClickIm (tab, event) {
      // console.log(tab)
      this.rankingByIMSellIndex = parseInt(tab.index) + 1
      this.handleGetIMRanking(this.rankingByIMSellIndex, this.rankingByIMSellCommand)
    },
    handleClickXS (tab, event) {
      // console.log(tab)
      this.handleGetXXRanking(tab.index)
    },
    handleClick (tab, event) {
      // console.log(tab)
    },
    handleCommandCompanyAll (command) {
      this.rankingByIMSellCommand = command
      this.changeValue = this.percentCompanyAll[command]
      this.handleGetIMRanking(this.rankingByIMSellIndex, command)
    },
    handleGetIMRanking (index, command) {
      // IM业绩排名/销售业绩
      this.$axios.get('/api/thread/order_sort', {
        params: {
          date_type: index,
          role_type: command
        }
      })
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.ranking = data.data
            this.rankingBySuccessOrder = data.data.rankingBySuccessOrder
            this.total_success_count = data.data.total_success_count
          }
        })
    },
    handleGetXXRanking (index) {
      // 销售通话时长
      this.$axios.get('/api/thread/duration_sort', {
        params: {
          date_type: parseInt(index) + 1
        }
      })
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.ranking = data.data
            this.rankingByCallDuration = data.data.rankingByCallDuration
            this.total_duration_count = data.data.total_duration_count
          }
        })
    },
    handleAddDrawerBeforeClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearAddData()
          done()
        })
        .catch(_ => {
        })
    },
    clearAddData () {
      this.activities = []
      this.OperationRecord = []
    },
    getVipCluesNum () {
    },
    handelGetOrders () {
      this.$axios.get('/api/thread/ranking', {
        params: {}
      })
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.ranking = data.data
            this.rankingBySuccessOrder = data.data.rankingBySuccessOrder
            this.rankingByCallDuration = data.data.rankingByCallDuration
            this.rankingByUserLevel = data.data.rankingByUserLevel
            this.rankingByImInputs = data.data.rankingByImInputs
            this.total_success_count = data.data.total_success_count
            this.total_duration_count = data.data.total_duration_count
            this.total_input_count = data.data.total_input_count
            for (var a = 0; a < this.rankingByUserLevel.length; a++) {
              this.rankingByUserLevel[a].level = this.vipGradeMethods(this.rankingByUserLevel[a].level)
            }
          }
        })
    },
    vipGradeMethods (key) {
      let vipData = [' ', '青铜', '白银', '黄金', '铂金', '钻石', '最强王者']
      return vipData[key]
    }
  },
  mounted () {
    this.handelGetOrders()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .public
    display flex
    width 100%
    box-sizing border-box
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-tabs >>> .el-tabs__header
    margin-bottom 0
  .ranking
    marginLeft()
    max-height: 100vh
    .header-style
      z-index: 2
      padding: 0px !important
    .main-style
      z-index: 1
      padding: 0px !important
      overflow-y: auto
    .ranking_list
      padding .2rem
      flex-direction row
      justify-content space-between
      .col_ranking
        box-sizing border-box
        width 100%
        background: #ffffff
        box-shadow: -8px 11px 38px -10px rgba(228, 230, 235, 0.55), 3px -1px 12px 3px rgba(228, 230, 235, 0.55)
        border-radius: 10px
        padding .6rem 0.6rem 0
        height auto
        min-height 11rem
        max-height 11rem
        box-sizing border-box
        margin-bottom .6rem
        .tabs_position
          display flex
          flex-direction row
          justify-content space-between
          text-align center
          width 100%
          height 1.4rem
          line-height 1.4rem
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .tr
    text-align: right

  .m-tabs-content
    height 6.5rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .text_right
      text-align left
    .el-row
      margin-bottom: .4rem
  .tabs_top
    justify-content space-between
    flex-direction row
    padding 0 .2rem
    border-bottom 1px solid #CCCCCC
    height 1rem
    line-height 1rem
    margin-bottom .1rem
    span
      font-size .28rem
  .tabs_topBorder
    border-bottom 1px solid #eeeeee
  .tabs_topBorder:nth-last-child(1)
    border-bottom 0
  .count_name
    text-align center
  .count_num
    text-align right
  .clues_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF

  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem;

  .mt-10
    margin-top: .2rem

  .el-select, .el-cascader
    width: 100%
  .el-dropdown-link {
    cursor: pointer;
    color: #333;
    font-size .3rem
  }
  .ranking_title
    color: #333
    font-size .3rem

  .el-icon-arrow-down {
    font-size: 12px;
  }
  /*滚动条整体样式*/
  ::-webkit-scrollbar {
    width: .1rem; /*竖向滚动条的宽度*/
    height: 10px; /*横向滚动条的高度*/
  }

  ::-webkit-scrollbar-thumb { /*滚动条里面的小方块*/
    background: #cdcdcd;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track { /*滚动条轨道的样式*/
    background: #f8f8f8;
    border-radius: 5px;
  }
  .el-date-editor
    width: 100% !important
</style>



// WEBPACK FOOTER //
// src/pages/ranking/ranking.vue